import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_FILE_BASIC_01_Schema } from './M_FILE_BASIC_01_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

/** 교육자료 조회 getFileCustomR1 (Global.urls.File 136-141) */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_FILE_BASIC_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['File', 'getFileCustomR1', params],
    queryFn: () => apiRequest('post', Global.urls.File.getFileCustomR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
